@if (showBanner === 'true') {
  <div class="system-banner-wrapper" [ngClass]="showBanner === 'true' ? 'system-banner-wrapper--show': ''">
    @for (promo of promotions; track $index) {
      <div >
        @if (promo?.showBanner) {
          <div class="system-banner">
            <ama-icon [size]="'1em'" [name]="'bell'" class="system-banner__icon ama-icon"></ama-icon>
            <div class="system-banner__container">
              <span class="system-banner__message">
                <strong>
                  {{promo?.disableUpdatesMessage}}
                </strong>
              </span>
            </div>
            <span class="system-banner__close" (click)="closeBanner()">
              <ama-icon [name]="'close'" size="1.25rem" class="ama-icon"></ama-icon>
            </span>
          </div>
        }
      </div>
    }
  </div>
}
